export default {"src":"/_next/static/media/dat.9109eb27.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};